export const MANUAL_PAYMENT_REFERENCE_NUMBER = "رقم عملية الدفع";
export const CASH_OUT_ENTER_AMOUNT = "أدخل المبلغ";

export const ACTION_ADMIN_CONFIRM_DELIVERY = "تاكيد التوصيل";
export const ACTION_ADMIN_DELETE_CONTRACT = "حذف العقد";

export const ACTION_ADMIN_RESOLVE_ESCALATION_REFUND_CUSTOMER =
  "حل المشكلة و ارجاع المبلغ للمشتري";
export const ACTION_ADMIN_RESOLVE_ESCALATION_RELEASE_PROVIDER =
  "حل المشكلة وتحويل المبلغ للبائع ";
export const ACTION_ADMIN_CLOSE_REFUND_CUSTOMER = "قم بارجاع المبلغ للمشتري";
export const ACTION_ADMIN_CLOSE_RELEASE_FUND_TO_PROVIDER =
  " قم بتحويل المبلغ للبائع";
export const ACTION_ADMIN_COMPLETE_RELEASE_FUND_TO_PROVIDER =
  "ارسال المبلغ للبائع";
export const ADMIN_DELETE_ITEM = "";
export const ACTION_SEND_MONEY_TO_PROVIDERS = "قبول العقد";
export const ACTION_SEND_MONEY_TO_PAYEES = "رفض العقد";
